import React, { FunctionComponent } from 'react';

import { SubscribeForm } from '@savebetter/components';

import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { Section } from './Section';

interface Blok extends PageSectionBlok {
  media: MediaProps[];
  heading: string;
  text: string;
  buttonLabel: string;
  inputLabel: string;
  inputPlaceholder: string;
}

interface SubscribeProps extends PageSectionProps {
  blok: Blok;
}

export const Subscribe: FunctionComponent<React.PropsWithChildren<SubscribeProps>> = ({ blok, sectionClassName }) => {
  const { hasBackground, hasBorder, media, heading, text, hasPaddingTop, hasPaddingBottom } = blok;

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <SubscribeForm
        mediaProps={{ src: media[0].img, alt: media[0].alt, loading: 'lazy' }}
        heading={heading}
        text={text}
        position="left"
      />
    </Section>
  );
};
